import { PREVENTION_MEASURES_VIEWS } from "@/entities/prevention-action/model/prevention-action.utils"
import { PREVENTION_MEASURE_ICONS } from "@/entities/prevention-action/model/prevention-action.icons"
import NavFocus from "@/nav/nav.focus"
import { SessionDashboardTab } from "@/redux/_session.types"
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons"
import { useLocation, useNavigate } from "react-router-dom"
import { PhysicalRiskSelectionActions, PhysicalRiskSelectionProvider } from "@/entities/physical-risk/ui/PhysicalRiskSelection"

interface Props {
  children: React.ReactNode
}

/** Onglets de la section "Prevention". Declares ici uniquement : le menu global les reprend en sous-menu. */
export const PREVENTION_TABS: SessionDashboardTab[] = [
  {
    id: "/risks/calendar",
    label: "Calendrier",
    icon: faCalendarDays
  },
  {
    id: "/risks/prevention-actions/in-place",
    label: PREVENTION_MEASURES_VIEWS["in-place"].title,
    icon: PREVENTION_MEASURE_ICONS["in-place"]
  },
  {
    id: "/risks/prevention-actions/to-plan",
    label: PREVENTION_MEASURES_VIEWS["to-plan"].title,
    icon: PREVENTION_MEASURE_ICONS["to-plan"]
  },
  {
    id: "/risks/prevention-actions/overdue",
    label: PREVENTION_MEASURES_VIEWS.overdue.title,
    icon: PREVENTION_MEASURE_ICONS.overdue
  },
  {
    id: "/risks/prevention-actions/missing",
    label: PREVENTION_MEASURES_VIEWS.missing.title,
    icon: PREVENTION_MEASURE_ICONS.missing
  },
  {
    id: "/risks/prevention-actions/planned",
    label: PREVENTION_MEASURES_VIEWS.planned.title,
    icon: PREVENTION_MEASURE_ICONS.planned
  }
]

export default function NavPrevention({ children }: Props) {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  return (
    <PhysicalRiskSelectionProvider key={pathname}>
      <NavFocus
        customActions={<PhysicalRiskSelectionActions />}
        tabs={PREVENTION_TABS}
        onBack={() => navigate("/home")}
        onAction={(path: string) => navigate(path)}>
        {children}
      </NavFocus>
    </PhysicalRiskSelectionProvider>
  )
}
